import { Flex, Text, Box, Image } from '@chakra-ui/react'

import { Carousel } from '../Carousel'

import Develope from '../../assets/develop.svg'
import { useEffect } from 'react'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
export const Projects = () =>{

    useEffect(()=>{
        gsap.registerPlugin(ScrollTrigger)

        gsap.from(".leftProjects", {
            x: -200,
            opacity: 0,
          });
          gsap.to(".leftProjects", {
            x: 0,
            opacity: 1,
            duration: 2,
            scrollTrigger: {
              trigger: "#projects",
              toggleActions: "restart play",
            },
          });


        gsap.from(".rightProjects", {
            x: 200,
            opacity: 0,
        });
        gsap.to(".rightProjects", {
            x: 0,
            opacity: 1,
            duration: 2,
            scrollTrigger: {
            trigger: "#projects",
            toggleActions: "restart play",
            },
        });
    },[])

    return(
        <Flex
            w="100%"
            h="100vh"
            bg="blue.300"
            overflowX="hidden"
            justifyContent="space-between"
            id="projects"
        >
            <Box
                padding="50px"
                display="flex"
                flexDir="column"
                justifyContent="space-around"
                className="leftProjects"
            >
                
                <Box>
                    <Text 
                        as="h2"
                        fontSize="4xl" 
                        fontWeight="bold"
                    >
                        Projetos
                    </Text>
                </Box>
                <Carousel/>
            </Box>
            <Image 
                className="rightProjects"
                padding="50px"
                w={["0", "0", "40%"]}
                src={Develope}
            />
        </Flex>
    )
}